import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();

  const handleAccept = () => {
    localStorage.setItem('shopcopilot_terms_accepted', 'true');
    navigate('/categories', { replace: true });
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>TÉRMINOS Y CONDICIONES DE USO</h2>
        <h4 style={styles.subtitle}>SHOPCOPILOT</h4>
        <p style={styles.updated}>
          <strong>Última actualización:</strong> 2/12/2026
        </p>

        <div style={styles.textBox}>
          <h4>1. Aceptación de los Términos</h4>
          <p>
            Al acceder, registrarse o utilizar la aplicación ShopCopilot (en
            adelante, la “Aplicación”), el usuario reconoce que ha leído,
            entendido y aceptado quedar legalmente obligado por los presentes
            Términos y Condiciones de Uso. Si el usuario no está de acuerdo con
            estos términos, deberá abstenerse de utilizar la Aplicación.
          </p>

          <h4>2. Descripción del Servicio</h4>
          <p>
            ShopCopilot es una plataforma digital de carácter informativo que
            permite a los usuarios visualizar y comparar precios de productos
            ofrecidos por distintos comercios minoristas.
          </p>
          <p>Los precios mostrados en la Aplicación se obtienen a partir de:</p>
          <ul>
            <li>Información recopilada por compradores independientes (“shoppers”)</li>
            <li>Recibos de compra</li>
            <li>Observaciones realizadas en tiendas físicas</li>
            <li>Otras fuentes públicas disponibles al consumidor</li>
          </ul>
          <p>
            ShopCopilot no vende productos, no procesa pagos y no actúa como
            intermediario comercial entre el usuario y los comercios.
          </p>

          <h4>3. Exactitud, Disponibilidad y Variabilidad de Precios</h4>
          <p>El usuario reconoce y acepta que:</p>
          <ul>
            <li>
              Los precios reflejan observaciones realizadas en una fecha, hora y
              ubicación específicas.
            </li>
            <li>
              Los precios pueden variar sin previo aviso debido a factores como:
            </li>
          </ul>
          <ul>
            <li>Diferencias entre sucursales</li>
            <li>Disponibilidad de inventario</li>
            <li>Promociones temporeras</li>
            <li>Descuentos por membresía</li>
            <li>Cupones</li>
            <li>Impuestos aplicables</li>
            <li>Cambios internos del comercio</li>
          </ul>
          <p>
            Los precios mostrados no constituyen una oferta vinculante ni
            garantizan el precio final que será cobrado en tienda.
          </p>
          <p>
            ShopCopilot no garantiza que los precios mostrados coincidan con los
            precios vigentes al momento de la compra.
          </p>

          <h4>4. Uso Informativo y Decisiones del Usuario</h4>
          <p>
            La información provista por ShopCopilot se ofrece únicamente con fines
            informativos. Cualquier decisión de compra tomada por el usuario se
            realiza bajo su propio criterio y responsabilidad.
          </p>
          <p>
            ShopCopilot no ofrece asesoramiento financiero, comercial ni legal.
          </p>

          <h4>5. No Afiliación con Comercios</h4>
          <p>
            ShopCopilot no está afiliado, patrocinado, autorizado ni respaldado
            por las tiendas, marcas, fabricantes o comercios cuyos productos o
            precios puedan mostrarse en la Aplicación.
          </p>
          <p>
            Los nombres comerciales, marcas y denominaciones se utilizan
            exclusivamente con fines identificativos y de referencia.
          </p>

          <h4>6. Limitación de Responsabilidad</h4>
          <ul>
            <li>Errores u omisiones en los precios publicados</li>
            <li>
              Diferencias entre el precio mostrado y el cobrado por el comercio
            </li>
            <li>
              Daños directos, indirectos, incidentales o consecuentes derivados
              del uso de la Aplicación
            </li>
            <li>
              Decisiones de compra basadas en la información provista
            </li>
          </ul>

          <h4>7. Modificaciones de los Términos</h4>
          <p>
            ShopCopilot se reserva el derecho de modificar estos Términos y
            Condiciones en cualquier momento. El uso continuado de la Aplicación
            después de la publicación de cambios constituirá aceptación de los
            términos modificados.
          </p>

          <h4>8. Ley Aplicable y Jurisdicción</h4>
          <p>
            Estos Términos y Condiciones se regirán e interpretarán conforme a las
            leyes del Estado Libre Asociado de Puerto Rico. Cualquier
            controversia estará sujeta a la jurisdicción de los tribunales
            competentes de Puerto Rico.
          </p>

          <h4>9. Contacto</h4>
          <p>
            Para preguntas o reclamaciones relacionadas con estos Términos, el
            usuario podrá comunicarse a través de los canales oficiales de
            ShopCopilot.
          </p>
        </div>

        <label style={styles.checkbox}>
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          />
          <span style={{ marginLeft: 8 }}>
            He leído y acepto los Términos y Condiciones
          </span>
        </label>

        <button
          style={{
            ...styles.button,
            opacity: accepted ? 1 : 0.5,
            cursor: accepted ? 'pointer' : 'not-allowed'
          }}
          disabled={!accepted}
          onClick={handleAccept}
        >
          Aceptar y Continuar
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: '100vh',
    background: '#0f172a',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  card: {
    background: '#ffffff',
    borderRadius: 0,
    padding: 24,
    maxWidth: 700,
    width: '95%',
    maxHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    marginBottom: 4
  },
  subtitle: {
    marginTop: 0,
    marginBottom: 8
  },
  updated: {
    fontSize: 13,
    marginBottom: 12,
    color: '#475569'
  },
  textBox: {
    flex: 1,
    overflowY: 'auto',
    fontSize: 14,
    color: '#334155',
    marginBottom: 16
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
    fontSize: 14
  },
  button: {
    padding: 12,
    background: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontWeight: 'bold'
  }
};

export default TermsAndConditions;
